'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
require("slick-carousel");
var Home;
(function (Home) {
    var MyHome = /** @class */ (function () {
        function MyHome() {
            this.spWidth = 768;
            this.interval = 7000;
            this.element = $('.bulletSlideAnime');
            this.speed = 1000;
            this.count = 0;
            var self = this;
            self.attachActiveContent();
            // self.stretchFirstView();
            // TOPページ用Slickスライダー
            self.productsSlick();
            /*
            window.addEventListener('resize', () => {
                self.stretchFirstView();
            });
            */
            var changeBackgroundAnimation = setInterval(function () {
                self.changeAnimation();
            }, this.interval);
        }
        // アニメーションの切り替え
        MyHome.prototype.changeAnimation = function () {
            var self = this;
            $(this.element[this.count]).stop().fadeOut(this.speed, function () {
                self.attachActiveContent();
            });
            var elementLength = this.element.length - 1;
            if (this.count >= elementLength) {
                this.count = 0;
            }
            else {
                this.count++;
            }
            $(this.element[this.count]).stop().fadeIn(this.speed);
        };
        // active classの付与
        MyHome.prototype.attachActiveContent = function () {
            $('.bulletSlideAnime').removeClass('active');
            $('.bulletSlideAnime').eq(this.count).addClass('active');
        };
        // ファーストビューの高さを変更
        MyHome.prototype.stretchFirstView = function () {
            var windowsHeight = $(window).outerHeight();
            var headerHeight = $('.paramHeaderContent').outerHeight();
            var firstViewHeight = Number(windowsHeight - headerHeight);
            $('.bulletFirstView').css('height', firstViewHeight);
        };
        //
        MyHome.prototype.productsSlick = function () {
            $('.bulletProductsSlick').slick({
                arrows: true,
                autoplay: false,
                accessibility: true,
                dots: true,
                infinite: true,
                prevArrow: '<i class="fa fa-angle-left slick-prev-btn"></i>',
                nextArrow: '<i class="fa fa-angle-right slick-next-btn"></i>',
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    }
                ]
            });
        };
        return MyHome;
    }());
    Home.MyHome = MyHome;
})(Home || (Home = {}));
exports.default = Home;
